import {
  HomePage,
  FaqsPage,
  ComerciosPage,
  TermsAndConditions,
  NoticeOfPrivacy,
  Redirect,
  RedirectPromoMegas,
  CashBack,
  StoresRedirect
} from './pages';

const routes = [
  {
    path: '/',
    component: HomePage
  },
  {
    path: '/faq',
    component: FaqsPage
  },
  {
    path: '/faq/:hide',
    component: FaqsPage
  },
  {
    path: '/comercios',
    component: ComerciosPage
  },
  {
    path: '/comercios/:hide',
    component: ComerciosPage
  },
  {
    path: '/terminos-y-condiciones',
    component: TermsAndConditions
  },
  {
    path: '/terminos-y-condiciones/:hide',
    component: TermsAndConditions
  },
  {
    path: '/aviso-de-privacidad',
    component: NoticeOfPrivacy
  },
  {
    path: '/aviso-de-privacidad/:hide',
    component: NoticeOfPrivacy
  },
  {
    path: '/redirect',
    component: Redirect
  },
  {
    path: '/rd',
    component: Redirect
  },
  {
    path: "/srd",
    component: StoresRedirect
  },
  {
    path: '/PromoMegas',
    component: RedirectPromoMegas
  },
  {
    path:'/dinerodevuelta',
    component: CashBack
  }
];

export default routes;